/**
 * Optional KuCoin EU marketing consent, shown in the join dialog of tournament 299 only.
 * The backend stores the same text (tb-backend src/api/kucoin-consent/constants.js); keep both in sync.
 */
export const KUCOIN_CONSENT_TOURNAMENT_ID = 299;

export const KUCOIN_CONSENT_TEXT =
  'I consent to Trading Battles sharing my email address with KuCoin EU for KuCoin EU marketing communications, subject to its Privacy Policy. I may withdraw my consent at any time.';

export const isKucoinConsentTournament = (tournamentId: unknown): boolean =>
  Number(tournamentId) === KUCOIN_CONSENT_TOURNAMENT_ID;
